import type React from 'react';

import { Skeleton } from '@/domains/core/tamagoshi/Skeleton/Skeleton';

import styles from './outlineBundleHeaderTitleSkel.module.scss';

const OutlineBundleHeaderTitleSkel: React.FC = () => (
  <div className={styles.titleSkelWrapper}>
    <Skeleton data-testid="outline-bundle-header-skeleton" height={24} />
  </div>
);

export default OutlineBundleHeaderTitleSkel;
